import * as React from 'react'
import { BusinessTripRate } from 'app/models/configuration/businessTripRatesConfigurationModel'
import { CountryModel } from 'app/models/timesheet/countryModel'
import { CurrencyModel } from 'app/models/newDelegation/currencyModel'

export type BusinessTripRatesTableContextValue = {
  rates: BusinessTripRate[]
  savedRates: BusinessTripRate[]
  availableCountries: CountryModel[]
  availableCurrencies: CurrencyModel[]
  handleUpdate: (rateId: number, updates: Partial<BusinessTripRate>) => void
  handleDelete: (rateId: number) => void
}

const BusinessTripRatesTableContext =
  React.createContext<BusinessTripRatesTableContextValue | null>(null)

export const useBusinessTripRatesTableContext = () => {
  const context = React.useContext(BusinessTripRatesTableContext)

  if (!context) {
    throw new Error(
      'useBusinessTripRatesTableContext must be used within BusinessTripRatesTableProvider',
    )
  }

  return context
}

type ProviderProps = React.PropsWithChildren<BusinessTripRatesTableContextValue>

export const BusinessTripRatesTableProvider: React.FC<ProviderProps> = ({
  children,
  ...value
}) => {
  return (
    <BusinessTripRatesTableContext.Provider value={value}>
      {children}
    </BusinessTripRatesTableContext.Provider>
  )
}
